import React, { PureComponent } from 'react';
import intl from 'react-intl-universal';
import { loadLocales } from './locale';
import Loading from '../components/Loading';

/**
 * 下载语言包，并重新加载被装饰的组件
 * @param Component
 * @returns {Wrapper}
 */
export const loadLang = (Component) => {
  class Wrapper extends PureComponent {
    // eslint-disable-next-line react/state-in-constructor
    state = {
      loading: true,
      currentLocale: 'en-US'
    };

    componentDidMount() {
      loadLocales((currentLocale) => {
        this.setState({
          loading: false,
          currentLocale
        });
        document.title = intl.get('app');
      });
    }

    render() {
      return this.state.loading ? (
        <Loading />
      ) : (
          <Component {...this.props} currentLocale={this.state.currentLocale} />
        );
    }
  }

  return Wrapper;
};

export default loadLang;
